
import { Options, Vue } from "vue-class-component";
import { mapState, mapActions, mapMutations } from "vuex";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueMultiselect from "vue-multiselect";
import Chart from "@/components/Chart.vue";
import Toggle from "@vueform/toggle";

@Options({
  components: {
    VueMultiselect,
    Chart,
    Toggle,
  },
  data() {
    return {
      //questions: [],
    };
  },
  computed: {
    adultQuestions() {
      return this.$store.state.adultQuestions;
    },
    ...mapState({
      isMainPercentage: (state: any) => state.isMainPercentage,
      mainQuestions: (state: any) => state.mainQuestions,
      sections: (state: any) => state.sections,
      selectedMainTopic: (state: any) => state.selectedMainTopic,
      selectedMainQuestion: (state: any) => state.selectedMainQuestion,
    }),
    currentMainTopic() {
      return this.selectedMainTopic;
    },
    currentMainQuestion() {
      return this.selectedMainQuestion;
    },
  },
  methods: {
    ...mapActions({
      getMetadata: "GET_METADATA",
      changeMainTopic: "CHANGE_MAIN_TOPIC",
      changeMainQuestion: "CHANGE_MAIN_QUESTION",
    }),
    ...mapMutations({
      changeIsMainPercentage: "SET_MAIN_PERCENTAGE",
    }),
  },
  mounted() {
    this.getMetadata();
  },
})
export default class Features extends Vue {}
